<section [formGroup]="formGroup">
    <div class="mat-checkbox-container">
        <mat-checkbox matInput
                      formControlName="alertsEmailEnabled"
                      name="alertsEmailEnabled"
                      class="form-control"
                      data-cy="alerts-checkbox">
            {{ 'settings_mail_form_enable_alerts' | translate }}
        </mat-checkbox>
    </div>
    <div class="mat-checkbox-container">
        <mat-checkbox matInput
                      formControlName="smtpUseDefaultCredentials"
                      name="smtpUseDefaultCredentials"
                      class="form-control"
                      data-cy="default-credentials-checkbox"
                      (change)="toggleSmtpSettingChangeStatus()">
            {{ 'settings_mail_form_use_default_credentials' | translate }}
        </mat-checkbox>
    </div>
    <div class="mat-checkbox-container">
        <mat-checkbox matInput
                      formControlName="smtpEnableSsl"
                      name="smtpEnableSsl"
                      class="form-control"
                      data-cy="ssl-checkbox"
                      (change)="toggleSmtpSettingChangeStatus()">
            {{ 'settings_mail_form_enable_ssl' | translate }}
        </mat-checkbox>
    </div>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_mail_form_smtp_host' | translate"
               (change)="toggleSmtpSettingChangeStatus()"
               matInput
               formControlName="smtpHost"
               name="smtpHost"
               class="form-control"
               data-cy="smtp-host" />
        <mat-hint *ngIf="!formGroup.get('smtpHost')!.pristine &&
                 formGroup.get('smtpHost')!.hasError('whitespace')"
                  translate
                  class="errorMessage">
            errors_general_whitespace
        </mat-hint>
        <mat-hint *ngIf="!formGroup.get('smtpHost')!.pristine &&
                            !formGroup.get('smtpHost')!.hasError('whitespace') &&
                            formGroup.get('smtpHost')!.hasError('maxlength')"
                  [translateParams]="{
                            max: formGroup.get('smtpHost')!.getError('maxlength').requiredLength
                        }"
                  translate
                  class="errorMessage">
            settings_mail_form_smtp_host_max_warning
        </mat-hint>
    </mat-form-field>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_mail_form_smtp_domain' | translate"
               (change)="toggleSmtpSettingChangeStatus()"
               matInput
               formControlName="smtpDomain"
               name="smtpDomain"
               class="form-control"
               data-cy="smtp-domain" />
        <mat-hint *ngIf="!formGroup.get('smtpDomain')!.pristine &&
                        formGroup.get('smtpDomain')!.hasError('whitespace')"
                  translate
                  class="errorMessage">
            errors_general_whitespace
        </mat-hint>
        <mat-hint *ngIf="!formGroup.get('smtpDomain')!.pristine &&
                            !formGroup.get('smtpDomain')!.hasError('whitespace') &&
                            formGroup.get('smtpDomain')!.hasError('maxlength')"
                  [translateParams]="{
                            max: formGroup.get('smtpDomain')!.getError('maxlength').requiredLength
                        }"
                  translate
                  class="errorMessage">
            settings_mail_form_smtp_domain_max_warning
        </mat-hint>
    </mat-form-field>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_mail_form_smtp_port' | translate"
               (change)="toggleSmtpSettingChangeStatus()"
               matInput
               uiRestrictInput="^[0-9]+$"
               formControlName="smtpPort"
               name="smtpPort"
               class="form-control"
               data-cy="smtp-port" />
        <mat-hint *ngIf="!formGroup.get('smtpPort')!.pristine &&
                 formGroup.get('smtpPort')!.hasError('range')"
                  [translateParams]="{ min: 1, max: 65535 }"
                  translate
                  class="errorMessage">
            settings_mail_form_smtp_port_range_warning
        </mat-hint>
    </mat-form-field>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_mail_form_smtp_username' | translate"
               (change)="toggleSmtpSettingChangeStatus()"
               matInput
               uiPreventAutofill
               formControlName="smtpUsername"
               name="smtpUsername"
               class="form-control"
               data-cy="smtp-username" />
        <mat-hint *ngIf="!formGroup.get('smtpUsername')!.pristine &&
                            formGroup.get('smtpUsername')!.hasError('whitespace')"
                  translate
                  class="errorMessage">
            errors_general_whitespace
        </mat-hint>
        <mat-hint *ngIf="!formGroup.get('smtpUsername')!.pristine &&
                            !formGroup.get('smtpUsername')!.hasError('whitespace') &&
                            formGroup.get('smtpUsername')!.hasError('maxlength')"
                  [translateParams]="{
                            max: formGroup.get('smtpUsername')!.getError('maxlength').requiredLength
                        }"
                  translate
                  class="errorMessage">
            settings_mail_form_smtp_username_max_warning
        </mat-hint>
    </mat-form-field>
    <mat-form-field>
        <input #passwordInput
               [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_mail_form_smtp_password' | translate"
               matInput
               uiPreventAutofill
               formControlName="smtpPassword"
               name="smtpPassword"
               type="password"
               autocomplete="off"
               class="form-control"
               data-cy="smtp-password"
               (change)="toggleSmtpSettingChangeStatus()" />
        <span matSuffix>
            <ui-password-toggle [element]="passwordInput"
                                [tooltipShow]="'password_toggle_show' | translate"
                                [tooltipHide]="'password_toggle_hide' | translate"></ui-password-toggle>
        </span>
        <mat-hint *ngIf="!formGroup.get('smtpPassword')!.pristine &&
                            !formGroup.get('smtpPassword')!.hasError('whitespace') &&
                            formGroup.get('smtpPassword')!.hasError('maxlength')"
                  [translateParams]="{
                            max: formGroup.get('smtpPassword')!.getError('maxlength').requiredLength
                        }"
                  translate
                  class="errorMessage">
            settings_mail_form_smtp_password_max_warning
        </mat-hint>
    </mat-form-field>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_mail_form_default_from_email' | translate"
               (change)="toggleSmtpSettingChangeStatus()"
               matInput
               formControlName="defaultFromAddress"
               name="defaultFromAddress"
               class="form-control"
               data-cy="default-from-address" />
        <mat-hint *ngIf="!formGroup.get('defaultFromAddress')!.pristine &&
                            !formGroup.get('defaultFromAddress')!.hasError('maxlength') &&
                            formGroup.get('defaultFromAddress')!.hasError('email')"
                  translate
                  class="errorMessage">
            settings_mail_form_email_invalid_warning
        </mat-hint>
        <mat-hint *ngIf="!formGroup.get('defaultFromAddress')!.pristine &&
                            formGroup.get('defaultFromAddress')!.hasError('maxlength')"
                  [translateParams]="{
                            max: formGroup.get('defaultFromAddress')!.getError('maxlength').requiredLength
                        }"
                  translate
                  class="errorMessage">
            settings_mail_form_default_from_email_max_warning
        </mat-hint>
    </mat-form-field>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_mail_form_default_from_name' | translate"
               (change)="toggleSmtpSettingChangeStatus()"
               matInput
               formControlName="defaultFromDisplayName"
               name="defaultFromDisplayName"
               class="form-control"
               data-cy="default-from-display-name" />
        <mat-hint *ngIf="!formGroup.get('defaultFromDisplayName')!.pristine &&
                 formGroup.get('defaultFromDisplayName')!.hasError('whitespace')"
                  translate
                  class="errorMessage">
            errors_general_whitespace
        </mat-hint>
        <mat-hint *ngIf="!formGroup.get('defaultFromDisplayName')!.pristine &&
                            !formGroup.get('defaultFromDisplayName')!.hasError('whitespace') &&
                            formGroup.get('defaultFromDisplayName')!.hasError('maxlength')"
                  [translateParams]="{
                            max: formGroup.get('defaultFromDisplayName')!.getError('maxlength').requiredLength
                        }"
                  translate
                  class="errorMessage">
            settings_mail_form_default_from_max_warning
        </mat-hint>
    </mat-form-field>
</section>
